import { Button } from 'react-bootstrap'
import React from 'react'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import { ISelectOption } from '../../../../../../types/IClassifier'
import { HouseConsignmentRowData } from '../../../../house-consignment/components/types'
import { ConsignmentDetail } from '../../../../consignment-detail/models/types'
import Checkbox from '../../../../../../components/p5/Checkbox'
import DeleteIcon from '../../../../../../components/icons/DeleteIcon'
import EditIcon from '../../../../../../components/icons/EditIcon'

const getCountryLabel = (country: string | null | undefined, countriesOptions: ISelectOption[]): string | undefined => {
  if (!country) {
    return undefined
  }

  return countriesOptions.find((countryOption) => countryOption.value === country)?.label
}

const resolveTrader = (
  houseTrader: ConsignmentDetail | null | undefined,
  fallbackName: string | null,
  fallbackCountry: string | null,
): { name: string | null; country: string | null } => {
  if (houseTrader?.name?.trim()) {
    return { name: houseTrader.name, country: houseTrader.address?.country ?? null }
  }
  return { name: fallbackName, country: fallbackCountry }
}

export interface TransitHouseConsignmentTableRowProps {
  houseConsignment: HouseConsignmentRowData
  houseConsignmentIndex: number
  consignmentConsignorName: string | null
  consignmentConsignorCountry: string | null
  consignmentConsigneeName: string | null
  consignmentConsigneeCountry: string | null
  onToggleConsignmentItems: () => void
  onRowEdit: () => void
  onRowRemove: () => void
  onRowSelect: () => void
  selected: boolean
  isExpanded: boolean
  editDisabled: boolean
  consignmentItemsToggleDisabled: boolean
}

function TransitHouseConsignmentsTableRow({
  houseConsignment,
  houseConsignmentIndex,
  consignmentConsignorName,
  consignmentConsignorCountry,
  consignmentConsigneeName,
  consignmentConsigneeCountry,
  onToggleConsignmentItems,
  onRowEdit,
  onRowRemove,
  onRowSelect,
  selected,
  isExpanded,
  editDisabled,
  consignmentItemsToggleDisabled,
} : TransitHouseConsignmentTableRowProps) {
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const consignor = resolveTrader(houseConsignment.consignor, consignmentConsignorName, consignmentConsignorCountry)
  const consignee = resolveTrader(houseConsignment.consignee, consignmentConsigneeName, consignmentConsigneeCountry)

  return (
    <tr
      className={`${houseConsignment.invalidCommodityData ? 'invalid-row' : ''} ${isExpanded ? 'hc-row-expanded' : ''} ${consignmentItemsToggleDisabled ? '' : 'hc-row-clickable'} ${selected ? 'row-selected' : ''}`}
      onClick={consignmentItemsToggleDisabled ? undefined : onToggleConsignmentItems}
    >
      <td className="w-1 align-middle">
        <Checkbox
          checked={selected}
          onChange={onRowSelect}
          onClick={(event) => event.stopPropagation()}
          wrapperClassName="d-flex align-items-center justify-content-center"
          inputClassName="form-check-input m-0 float-none"
        />
      </td>
      <td className="sequence-nr">{houseConsignmentIndex + 1}</td>
      <td>{consignor.name}</td>
      <td>{getCountryLabel(consignor.country, countriesOptions)}</td>
      <td>{consignee.name}</td>
      <td>{getCountryLabel(consignee.country, countriesOptions)}</td>
      <td>
        <Button
          type="button"
          variant="link"
          className="goods-toggle"
          onClick={(event) => {
            event.stopPropagation()
            onToggleConsignmentItems()
          }}
          active={isExpanded}
          disabled={consignmentItemsToggleDisabled}
          title="goods"
        >
          <span className={`goods-toggle__count ${houseConsignment.invalidCommodityData ? 'goods-toggle__count--invalid' : ''}`}>
            {houseConsignment.numberOfGoods}
          </span>
        </Button>
      </td>
      <td className="text-end">
        <div className="d-flex align-items-center justify-content-end gap-2">
          <Button
            type="button"
            variant="link"
            className="btn-icon"
            onClick={(event) => {
              event.stopPropagation()
              onRowEdit()
            }}
            disabled={editDisabled}
          >
            <EditIcon />
          </Button>
          <Button
            type="button"
            variant="link"
            className="btn-trash"
            onClick={(event) => {
              event.stopPropagation()
              onRowRemove()
            }}
            disabled={editDisabled}
          >
            <DeleteIcon />
          </Button>
        </div>
      </td>
    </tr>
  )
}

export default TransitHouseConsignmentsTableRow
